import React, { useEffect, useState } from "react";
import moment from "moment";
import {} from "../../../../Redux/Actions/actions";
import { connect } from "react-redux";
import axios from "axios";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { Stack, Typography } from "@mui/material";
import { ArrowsLeftRight, ArrowsMerge } from "@phosphor-icons/react";
import nodata from "../../../../Assets/images/svg/Data-unavailable.svg";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const Sessiontab = (props) => {
  const [userchathistory, setUserchathistory] = useState([]);

  const getChatHistoryDetails = async () => {
    try {
      const sessions = await axios.post(
        BaseUrl + "/users/listchatHistory",
        {
          session_id: props.externalChatData
            ? props.externalChatData.chat_session_id
            : "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      );
      if (sessions.data.status) {
        setUserchathistory(sessions.data.data);
      } else {
        setUserchathistory([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getChatHistoryDetails();
  }, [props.externalChatData]);

  return (
    <>
      <div
        className="d-flex justify-content-end"
        style={{ height: "5px" }}
      ></div>
      <div
        className="historynew CONTACT-LIST-AREA"
        style={{
          height: "calc(100% - 5px)",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        {userchathistory.length > 0 ? (
          userchathistory.map((item) => {
            return (
              <div
                className="row m-2 border p-2 justify-content-center align-items-center bg-white"
                style={{ borderRadius: "8px" }}
              >
                <Stack direction={"row"} alignItems={"center"} spacing={1}>
                  {item.type == "Transfer" ? (
                    <ArrowsLeftRight size={30} cursor={"pointer"} />
                  ) : (
                    <ArrowsMerge size={30} cursor={"pointer"} />
                  )}
                  <Stack sx={{ flex: 1 }}>
                    <Typography variant="subtitle2">
                      {item.type == "Transfer" ? (
                        <>
                          Interaction Transferred From {item.agent} to{" "}
                          {item.destinationAgent}
                        </>
                      ) : (
                        <>
                          {item.agent} conferenced with {item.destinationAgent}
                        </>
                      )}
                    </Typography>
                    <Typography variant="caption">
                      {moment(item.time).format("LLL")}
                    </Typography>
                  </Stack>
                </Stack>
              </div>
            );
          })
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <span className="mx-auto">
              <img
                src={nodata}
                alt="nodata"
                style={{ width: "13rem", userSelect: "none" }}
              />
            </span>
            <span className="mx-auto">
              <h6 className="text-muted mt-2 fs-13">No data found</h6>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default connect(mapStateToProps, {})(Sessiontab);
